export function gtmTrackEvent(payload) {
  const data = {
    event: 'ecommerce-event',
    ecommerce: payload
  };
  dataLayer.push(data);
}

export function gtmTrackSwathOnlyPurchaseEvent(payload) {
  const data = {
    event: 'ecommerce-event-swatch',
    ecommerce: payload
  };
  dataLayer.push(data);
}

export function formatGTMDataForProductImpressions(products, list) {
  localStorage.setItem('gtm_list', list);
  return {
    currencyCode: 'USD',
    impressions: products.map(product => ({
      ...formatGTMDataForProduct(product),
      list: list
    }))
  };
}

export function formatGTMDataForProductDetails(product) {
  const list = localStorage.getItem('gtm_list') ?? '';
  return {
    detail: {
      actionField: { list: list },
      products: [formatGTMDataForProduct(product)]
    }
  };
}

export function formatGTMDataForAddToCart(product, quantity) {
  const list = localStorage.getItem('gtm_list') ?? '';
  return {
    currencyCode: 'USD',
    add: {
      actionField: { list: list },
      products: [{ ...formatGTMDataForProduct(product), quantity: quantity }]
    }
  };
}

export function formatGTMDataForRefund(order, orderProducts) {
  return {
    refund: {
      actionField: { id: order.id },
      products: orderProducts.map(orderProduct => ({
        id: orderProduct.product.id,
        quantity: orderProduct.quantity
      }))
    }
  };
}

export function formatGTMDataForCheckoutStep(step, name, cartProducts) {
  const list = localStorage.getItem('gtm_list') ?? '';
  return {
    checkout: {
      actionField: { step: step, option: name, list: list },
      products: cartProducts.map(cartProduct => ({
        ...formatGTMDataForProduct(cartProduct.product),
        quantity: cartProduct.quantity
      }))
    }
  };
}

export function formatGTMDataForPurchase(order) {
  return {
    purchase: {
      actionField: {
        id: order.id,
        revenue: order.total,
        tax: order.taxes,
        shipping: order.shipping_cost,
        coupon: order.discountsRelation.lengths
          ? order.discountsRelation[0].code
          : ''
      },
      products: order.orderProducts.map(orderProduct => ({
        ...(orderProduct.product
          ? formatGTMDataForProduct(orderProduct.product)
          : formatGTMDataForGiftCard(orderProduct.giftCard)),
        quantity: orderProduct.quantity
      }))
    }
  };
}

export function formatGTMDataForProduct(product) {
  return {
    id: product.id,
    sku: product.sku,
    name: product.name,
    price: product.price,
    frame: product.frame?.name,
    fabric: product.fabric?.name,
    subcategory:
      product.frame?.subcategories?.length > 0
        ? product.frame?.subcategories[0].name
        : '',
    category:
      product.frame?.subcategories?.length > 0
        ? product.frame?.subcategories[0].category.name
        : ''
  };
}

export function formatGTMDataForGiftCard(giftCard) {
  return {
    id: 'gift-card',
    sku: 'gift-card',
    name: 'Gift Card',
    price: giftCard.original_balance
  };
}
